const substringsToCheck = ['nome', 'nm_pessoa', 'nm_mun', 'sigla_uf'];

export function shouldApplyNotranslate (attr: { nm_alias?: string; nm_coluna?: string }): boolean {
  return substringsToCheck.some(substring =>
    attr.nm_alias?.includes(substring) || attr.nm_coluna?.includes(substring)
  );
};
